import { render, staticRenderFns } from "./EventStats.vue?vue&type=template&id=8e670986&scoped=true"
import script from "./EventStats.vue?vue&type=script&lang=ts"
export * from "./EventStats.vue?vue&type=script&lang=ts"
import style0 from "./EventStats.vue?vue&type=style&index=0&id=8e670986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e670986",
  null
  
)

export default component.exports